import { Link } from 'react-router-dom';
import AuthStatus from '../auth/AuthStatus';
import Language from '../../login/components/Language';
import { config } from '../config';

type HeaderProps = { logo: string };

const Header = ({ logo }: HeaderProps) => {
  return (
    <header className="flex justify-between header relative">
      <Link to="/" className="flex items-center p-1">
        <img src={logo} alt="" className="h-16 mb-auto" />
      </Link>
      <div className="p-1 text-sm text-right flex flex-col justify-between">
        {config.languagesEnabled && <Language />}
        <AuthStatus />
      </div>
    </header>
  );
};

export default Header;
